<iho-top-nav *ngIf="!isInMapPage" ngSkipHydration (toggleDrawer)="toggleDrawer($event)" [userDataTopNav]="userData()"
  [isLoading]="_isLoadingAuth()"></iho-top-nav>


<main class="relative" role="main">
  <router-outlet></router-outlet>
</main>


<iho-footer *ngIf="!isInMapPage" class="mb-16 md:mb-0"
  [phoneNumber]="(resPhoneApi | async)?.SupportPhone"></iho-footer>
 <!-- <div class="container" *ngIf="!isInMapPage">
  <iho-footer-ds></iho-footer-ds>
 </div> -->

 <div class="mb-6">
   <iho-side-menu *ngIf="!isInMapPage" [isOpen]="drawerIsOpen" (toggleDrawer)="toggleDrawer($event)">
   </iho-side-menu>
 </div>